import { gate } from 'hub-http/gates';
export const CHANNEL_MANAGER_EXP_CALLING_TRIALS = gate('ChannelManagerExp:CallingTrials');
export const CHANNEL_MANAGER_EXP_INTERNATIONAL_PHASE_3 = gate('Channel:Manager:InternationalPhase3');
export const CHANNEL_MANAGER_EXP_INTERNATIONAL_PORTING = gate('Channel:Manager:InternationalPorting');
export const CHANNEL_MANAGER_EXP_INTERNATIONAL_PHASE_4 = gate('Channel:Manager:InternationalPhase4');
export const CALLING_MANAGER_EXP_PHONE_NUMBER_VERIFICATION = gate('ChannelManagerExp:PhoneNumberVerification');
export const CALLING_MANAGER_EXP_RECORDING_CONSENT = gate('ChannelManagerExp:RecordingConsent');
export const CALLING_REP_VOICEMAIL_DROP = gate('Calling:Rep:VoicemailDrop');
export const ALL_PROPERTIES_PANEL = gate('CRM:Records:AllPropertiesPanel');